export const getDefaultCognitoAuthConfigurationFromEnvVariables = () => ({
  userPoolId: process.env.VITE_AWS_COGNITO_USER_POOL_ID,
  userPoolClientId: process.env.VITE_AWS_COGNITO_USER_POOL_CLIENT_ID,
  ...(process.env.VITE_AWS_COGNITO_ENDPOINT
    ? { userPoolEndpoint: process.env.VITE_AWS_COGNITO_ENDPOINT }
    : {}),
});
